import {
  AccountInviteUsersUrl,
  AccountInviteUserUrl
} from '../utils/agentUrls'
import {
  genericPostRequestToApi
} from '../utils/genericRequests'
import moment from 'moment'

const inviteClients = (data) => {
  return genericPostRequestToApi(AccountInviteUsersUrl(), data)
}
const inviteSingleClient = (data) => {
  return genericPostRequestToApi(AccountInviteUserUrl(), data)
}
const onSendInviteClicked = async(clientData, agentData) => {
  const inviteBuyerPayload = {
    name: clientData.name,
    phone: clientData.phone,
    email: clientData.email
  }
  await inviteSingleClient(inviteBuyerPayload)
  const updatedProfile = { ...agentData }
  updatedProfile.clients.forEach(item => {
    if (item.email === clientData.email) {
      item.agents.push({
        ...clientData.agents[clientData.agents.length - 1],
        ...{ ts: new Date() }
      })
    }
  })
  return updatedProfile
}

const dateOfLastInvite = (profile) => {
  const date = moment(profile.agents[profile.agents.length - 1].ts).fromNow()
  return !(date.includes('day') || date.includes('month'))
}

const dateOfLastFeedback = (lastFeedbackMessages) => {
  const date = moment(lastFeedbackMessages).fromNow()
  return !(date.includes('day') || date.includes('month'))
}

export {
  inviteClients,
  inviteSingleClient,
  onSendInviteClicked,
  dateOfLastInvite,
  dateOfLastFeedback
}
